import gql from 'graphql-tag'

// Agency role: Hasura permissions limit every field here to the account's campaigns.
export const GET_MY_SUBSCRIBERS_QUERY = gql`
  query ($limit: Int = 10, $offset: Int = 0, $where: subscriber_bool_exp = {}) {
    subscriber(
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
      where: $where
    ) {
      id
      firstname
      lastname
      email
      phone
      zip
      additional_info
      is_active
      created_at
      audiences_by_subscribers {
        audienceData {
          name
        }
      }
    }
    subscriber_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

export const GET_MY_CAMPAIGNS_QUERY = gql`
  query {
    audience(order_by: { name: asc }) {
      id
      name
    }
  }
`
